import {
  DEFAULT_LAYER_STYLE,
  type LayerStyle,
  parseLayerColor,
  parseLayerLineStyle,
  parseLayerLineWeight,
} from '@trimble/geospatial';
import { type ConnectMapsWebApiDtosResponsesGeoLayer } from '../generated';

interface MapsLayerStyleJson {
  lineColor?: unknown;
  lineStyle?: unknown;
  lineWeight?: unknown;
}

// The layer's own style wins over its template's default colour.
export function toLayerStyle(
  item: ConnectMapsWebApiDtosResponsesGeoLayer
): LayerStyle {
  const style: MapsLayerStyleJson =
    item.style != null && typeof item.style === 'object' ? item.style : {};
  return {
    color:
      parseLayerColor(style.lineColor) ??
      parseLayerColor(item.template?.geometryColorHexRGB) ??
      DEFAULT_LAYER_STYLE.color,
    lineStyle: parseLayerLineStyle(style.lineStyle),
    lineWeight: parseLayerLineWeight(style.lineWeight),
  };
}
